export { localToday } from "./testLibrary";

export const ZONES = [
  ["cabeza_cuello", "Cabeza / cuello", false], ["hombro", "Hombro", true], ["brazo_codo_muneca", "Brazo / codo / muñeca", true],
  ["espalda_alta", "Espalda alta", false], ["lumbar", "Zona lumbar", false], ["abdomen", "Abdomen", false],
  ["cadera_ingle", "Cadera / ingle", true], ["aductor", "Aductor", true], ["gluteo", "Glúteo", true],
  ["cuadriceps", "Cuádriceps", true], ["isquiotibiales", "Isquiotibiales", true], ["rodilla", "Rodilla", true],
  ["gemelo_soleo", "Gemelo / sóleo", true], ["aquiles", "Tendón de Aquiles", true], ["tobillo", "Tobillo", true],
  ["pie", "Pie", true], ["otra", "Otra zona", false],
];
export const ZONE_LABEL = Object.fromEntries(ZONES.map(([k, l]) => [k, l]));
export const SIDES = [["izquierda", "Izq."], ["derecha", "Dcha."], ["ambos", "Ambos"]];
export const ONSET = { durante: "Durante el entrenamiento", despues: "Después de entrenar", fuera: "Fuera del entrenamiento" };
export const PAIN_TYPE = {
  muscular_habitual: ["Molestia muscular habitual", "Cargado, agujetas, sensación difusa que mejora al calentar"],
  localizado: ["Dolor localizado", "En un punto concreto, pinchazo o dolor que limita el movimiento"],
};
export const LEVEL_COLOR = { alta: "#4ade80", buena: "#a3e635", moderada: "#facc15", baja: "#fb923c", revisar: "#f87171" };
export const zoneText = (zs) => (zs || []).map((z) => `${ZONE_LABEL[z.zone] || z.zone}${z.side && z.side !== "central" ? ` (${z.side})` : ""}`).join(", ");
export const tzOffset = () => -new Date().getTimezoneOffset();
